import {Route,Switch} from 'react-router-dom';
import {lazy} from 'react';
import ProtectedRoute from './ProtectedRoutes';
import SettingsRoute from './SettingsRoute';
import ConfigSuspense from './ConfigSuspense';
import { Loader } from '@src/components';

const Home=lazy(()=>import('@src/components/Home/Home'));
const Email=lazy(()=>import('@src/components/Auth/Email'));
const Login=lazy(()=>import('@src/components/Auth/Login'));
const Signup=lazy(()=>import('@src/components/Auth/Signup'));
const AddProfile=lazy(()=>import('@src/components/Register/AddProfile'));
const Contact = lazy(() => import('@src/components/Home/Contact'));
const About = lazy(() => import('@src/components/Home/About'));
const Forgotpassword = lazy(() => import('@src/components/Auth/Forgotpassword'));
const DeliveryAddress = lazy(() => import('@src/components/Register/DeliveryAddress'));
const Levels=lazy(()=>import('@src/components/Register/Levels'));
const GuestLevels=lazy(()=>import('@src/components/Guest/GuestLevels'));
const GuestCourses=lazy(()=>import('@src/components/Guest/GuestCourses'));
const GuestStory=lazy(()=>import('@src/components/Home/Stories/GuestStory.jsx'));
const GuestStoryCard=lazy(()=>import('@src/components/Home/Stories/GuestStoryCard.jsx'));
const Levelverify=lazy(()=>import('@src/components/Register/Levelverify'));
const SelectProfile=lazy(()=>import('@src/components/Auth/SelectProfile'));
const Userplans = lazy(() => import('@src/components/Subscription/Userplans'));
const Showuserplans = lazy(() => import('@src/components/Subscription/Displayuserplan'));
const GiftActivation = lazy(() => import('@src/components/Coupons/GiftActivation'))
const Timeup = lazy(() => import('@src/components/Timer/Timeup'))
const Faq = lazy(() => import('@src/components/Home/Faqscreen'));
const Settings=lazy(() => import( '@src/components/Settings/Settings' ) );
const Verify = lazy(() => import('@src/components/Settings/Verify'));
const Payment = lazy(() => import('@src/components/Payments/Payment'));
const Merchandise=lazy(() => import( '@src/components/Register/Mercandise' ) );
const UpdateFirstchild=lazy(() => import( '@src/components/Register/UpdateFirstchild' ) );

const GiftReady = lazy( () => import( '@src/components/Coupons/GiftReady' ) );

const PageNotFound = lazy(() => import('@src/components/Shared/404.jsx' ) );
const PaymentSuccess = lazy( () => import( '@src/components/Payments/PaymentSuccess' ) );

const MainRoute=()=>{
    return (
        <ConfigSuspense fallback={<Loader />}>
            <Switch>
                <ProtectedRoute  exact path='/(home)?/(stories|courses)?/(watch/.*)?' component={Home} />
                <ProtectedRoute  exact path='/delivery' component={DeliveryAddress} />
                <ProtectedRoute  exact path='/plans' component={ Userplans } />
                <ProtectedRoute  exact path='/gift-activated' component={GiftActivation} />
                <ProtectedRoute  exact path='/timeup' component={Timeup} />
                <ProtectedRoute path='/verification' component={Verify} />
                <ProtectedRoute path='/payment' component={Payment} />
                <ProtectedRoute path='/merchandise' component={Merchandise} />
                <ProtectedRoute path='/updatefirstchild' component={UpdateFirstchild} />
                <ProtectedRoute path='/gift-ready' component={ GiftReady } />
                <SettingsRoute path='/settings' component={ Settings } />
                <Route path='/welcome' component={Email}/>
                <Route path='/login' component={Login}/>
                <Route path='/signup' component={Signup}/>
                <Route path='/add-profile' component={ AddProfile } />
                <Route path='/levels' component={ Levels } />
                <Route path='/guestlevels' component={ GuestLevels } />
                <Route path='/guestcourses' component={ GuestCourses } />
                <Route path='/gueststory' component={ GuestStory } />
                {/* <Route path='/gueststorycard' component={ GuestStory } /> */}
                <Route path='/levelverify' component={ Levelverify } />
                <Route path='/profiles' component={ SelectProfile } />
                <Route path='/contact' component={Contact}/>
                <Route path='/about' component={About} />
                <Route path='/userplans' component={Showuserplans} />
                <Route path='/forgotpassword' component={Forgotpassword} />
                <Route path='/faq' component={Faq} />
                <Route path='/(paymentsuccess)?' component={PaymentSuccess}/>
                <Route path= '*' component = { PageNotFound } />
            </Switch>
        </ConfigSuspense>
    )
}

export {MainRoute};